import React from 'react';
import { Icon } from '../Icon';
import styles from './PaywallFaqV1.css';

const FAQ_ITEMS = [
    ['What exactly am I paying for?', 'Access to Boundly while your plan is active: the questions, the chapters we write from your answers, your edits, and your private link. Cancel anytime, in 2 taps from your profile.'],
    ['I’m not a writer. Is that a problem?', 'No. You talk or type, like you would to someone who just listens, and we turn it into written pages in your voice. You can edit anything.'],
    ['Will it work on my phone?', 'Yes. Boundly opens in your phone’s browser. Nothing to install.'],
    ['Who gets to read my stories?', 'Only you. Stories are private by default. If you want to share one, you pick the person and they get a password-protected link that opens on any device.'],
    ['What happens to my stories if I cancel?', 'Everything you’ve already written stays yours. You just can’t add new stories.'],
    ['How do I cancel?', 'Cancel anytime, in 2 taps from your profile.']
];

function PaywallFaqV1() {
    return (
        <div className={styles.root}>
            {FAQ_ITEMS.map(([question, answer], index) => (
                <details className={styles.item} key={question} open={index === 0}>
                    <summary className={styles.question}>
                        <span>{question}</span>
                        <Icon name='chevronDown' className={styles.chevron} />
                    </summary>
                    <p className={styles.answer}>{answer}</p>
                </details>
            ))}
        </div>
    );
}

export {
    PaywallFaqV1
};
